<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12m-.598-3.6 4.242-4.243-.849-.848-3.393 3.394-1.698-1.697-.848.848z"
	/>
</svg>
